import {ChangeDetectionStrategy, Component, effect, HostBinding, inject, input, OnDestroy, OnInit} from '@angular/core';
import {HeadService} from '@core/services/head.service';
import {BreadcrumbService} from '@core/services/breadcrumb.service';
import {StoryblokActionsService} from '@core/services/storyblok-actions.service';
import {StoryblokDirective} from '@core/directives/storyblok.directive';

import {DynamicModule} from 'ng-dynamic-component';
import {NgComponentOutlet} from '@angular/common';
import {StoryblokBaseComponent} from '../storyblok-base.component';
import {StoryblokComponentService} from '@core/services/storyblok-component.service';
import {StoryblokDynamicInputService} from '@core/services/storyblok-dynamic-input.service';

@Component({
  selector: 'app-storyblok-page',
  templateUrl: './storyblok-page.component.html',
  styleUrls: ['./storyblok-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [StoryblokDirective, DynamicModule, NgComponentOutlet]
})
export class StoryblokPageComponent extends StoryblokBaseComponent implements OnInit, OnDestroy {
  private headService = inject(HeadService);
  private breadcrumbService = inject(BreadcrumbService);
  private storyblockActionsService = inject(StoryblokActionsService);
  private storyblokComponentService = inject(StoryblokComponentService);
  private storyblokDynamicInputService = inject(StoryblokDynamicInputService);

  components: any;

  readonly body = input<any[]>();
  readonly actions = input<any[]>();
  readonly _editable = input<any>();
  readonly seo = input<any>();
  readonly noindex = input<any>();
  readonly og_type = input<any>();
  readonly priority = input<any>();
  readonly canonical = input<any>();
  readonly shortlink = input<any>();
  readonly breadcrumbs = input<any>();
  readonly og_site_name = input<any>();
  readonly og_updated_time = input<any>();
  readonly breadcrumb_style = input<any>();
  readonly article_modified_time = input<any>();
  readonly article_published_time = input<any>();

  primary_color = input<string>();
  primary_text_color = input<string>();
  secondary_color = input<string>();
  @HostBinding('style.--primary-color') primaryColor: any = '';
  @HostBinding('style.--primary-text-color') primaryTextColor: any = '';
  @HostBinding('style.--secondary-color') secondaryColor: any = '';

  constructor() {
    super()
    this.components = this.storyblokComponentService.getComponents();
    effect(() => {
      this.primaryColor = this.storyblokDynamicInputService.replaceDynamicInputs(this.primary_color() ?? '', true)();
      this.primaryTextColor = this.storyblokDynamicInputService.replaceDynamicInputs(this.primary_text_color() ?? '', true)();
      this.secondaryColor = this.storyblokDynamicInputService.replaceDynamicInputs(this.secondary_color() ?? '', true)();
    });
  }

  ngOnInit() {
    this.storyblockActionsService.executeActions(this.actions() ?? []);
  }

  ngOnDestroy() {
    this.headService.isAutoHeadersEnabled = true;
    this.breadcrumbService.isAutoChangeEnabled = true;
  }
}
